import { IVendorAuditApiResponse, IVendorUser } from "@/context/data.types";
import { IVendorCompanyInformationFormData } from "@/types/VendorManagement.types";

export const DefaultVendorCompanyInformationFormData: IVendorCompanyInformationFormData = {
  companyName: "",
  country: "",
  address: "",
  city: "",
  stateRegionProvince: "",
  zipCodePostalCode: "",
  vendorNumber: "",
};

export const initializeVendorUser = (vendorUser: any): IVendorUser => {
  return {
    temporaryId: vendorUser?.temporaryId || '',
    id: vendorUser?.id || '',
    vendorFirstName: vendorUser?.vendorFirstName || '',
    vendorLastName: vendorUser?.vendorLastName || '',
    vendorEmailAddress: vendorUser?.vendorEmailAddress || '',
    vendorRoleName: vendorUser?.vendorRoleName || '',
    vendorGroupName: vendorUser?.vendorGroupName || '',
    isVendorChampion: vendorUser?.isVendorChampion || false
  }
} 

export const initializeVendorAuditDetailsForm = (vendorAuditDetails: IVendorAuditApiResponse): IVendorAuditApiResponse => {
  return {
    id: vendorAuditDetails?.id || "",
    siteName: vendorAuditDetails?.siteName || "",
    orbcSiteCode: vendorAuditDetails?.orbcSiteCode || "",
    productPortalSiteId: vendorAuditDetails?.productPortalSiteId || "",
    skuNumber: vendorAuditDetails?.skuNumber || null,
    auditStatus: vendorAuditDetails?.auditStatus || "",
    productName: vendorAuditDetails?.productName || [],
    vendorName: vendorAuditDetails?.vendorName || null,
    auditScore: vendorAuditDetails?.auditScore || {id: '', value: ''},    
    auditPersonResponsible: vendorAuditDetails?.auditPersonResponsible || "",   
    auditTemplate: vendorAuditDetails?.auditTemplate || "",
    regulatoryGovernance: vendorAuditDetails?.regulatoryGovernance || "",
    summary: vendorAuditDetails?.summary || "",
    fsvp: (vendorAuditDetails?.fsvp === null || vendorAuditDetails?.fsvp === '') ? undefined : vendorAuditDetails?.fsvp,
    fsvp1AuditQuestionnaire: vendorAuditDetails?.fsvp1AuditQuestionnaire || [],
    fsvp2AuditQuestionnaire: vendorAuditDetails?.fsvp2AuditQuestionnaire || [],
    foodAndSafetyDocuments: vendorAuditDetails?.foodAndSafetyDocuments || [],
    auditStartDate: vendorAuditDetails?.auditStartDate || "",
    auditFinishDate: vendorAuditDetails?.auditFinishDate || "",
    auditDueDate: vendorAuditDetails?.auditDueDate || "",
    certificationExpirationDate: vendorAuditDetails?.certificationExpirationDate || "",
  }
}
